/* eslint-disable eqeqeq */
import {
  Box,
  Container,
  LinearProgress,
  Link,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppBaseScreen from "../../components/AppBaseScreen";
import { theme } from "./theme";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPockytConnectedBanks } from "../../store/actions";
import KycBlocked from "../withdraw/components/KycBlocked";
import KyconHold from "../withdraw/components/KyconHold";
import { useNavigate } from "react-router-dom";
import KycPending from "../withdraw/components/KycPending";
import { BANK_MODE, paymentOptions } from "../../utils/constants";
import { isBlockedUser } from "../../utils";
import AppScreenLoader from "../../components/AppScreenLoader";
import ClearJunction from "../withdraw/components/withdraw-options/clear-junction";
import OptionSelect from "../withdraw/components/common-steps/OptionSelect";
import AppDialogHalfScreen from "../../components/AppDialogHalfScreen";
import AppButton from "../../components/AppButton";
import { HomeOutlined } from "@mui/icons-material";

const Bank = () => {
  const [active, setActive] = useState(2);
  const { t } = useTranslation();
  const [caluclate] = useState(33.33);
  const dispatch = useDispatch();
  const bankFlag = useSelector(({ transfer }) => transfer.connectBank);
  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const navigate = useNavigate();
  const [showKyt, setShowKyt] = useState(false);
  const [showKytBlocked, setShowKytBlocked] = useState(false);
  const [showKycReview, setShowKycReview] = useState(false);
  const [country, setCountry] = useState(null);
  const [currency, setCurrency] = useState(null);
  const user = useSelector(({ Auth }) => Auth.user);
  const [isConflict, setIsConflict] = useState(false);
  const [fiatOption, setFiatOption] = useState(null);
  const [destinationRecord, setDestinationRecord] = useState(null);
  const [optionSelectMode, setOptionSelectMode] = useState("country-currency");
  const checkKyc = () => {
    if (isBlockedUser(user.kycStatus)) {
      setShowKytBlocked(true);
    } else if (
      // eslint-disable-next-line eqeqeq
      user.kycStatus == 4
    ) {
      setShowKycReview(true);
    } else if (
      // eslint-disable-next-line eqeqeq
      user.kycStatus != 2
    ) {
      setShowKyt(true);
    }
  }
  useEffect(() => {
    dispatch(getPockytConnectedBanks());
    checkKyc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleVerification = () => {
    setShowKyt(false);
    navigate("/verification");
  };
  if (!fiatService || !Object.keys(fiatService).length) {
    return <AppScreenLoader />
  }

  const isAddFlow = bankList?.length === 0 || bankFlag;
  const bankHeaderTitle = isAddFlow
    ? optionSelectMode === "transfer-method"
      ? t("currencyOptions")
      : t("pockyt.step1")
    : t("bankAccount");

  return (
    <AppBaseScreen
      isHeader={true}
      showLogo={false}
      headerSubTitle1={bankHeaderTitle}
      navigate={true}
      navigatePath={active == 2 ? "/home" : () => setActive(active - 1)}

      backText={active == 2 ? "Home" : ""}
    >
      <ThemeProvider theme={theme}>
        <KycPending
          active={active}
          handleVerification={handleVerification}
          setShowKyt={setShowKyt}
          showKyt={showKyt}
          payment={paymentOptions.pockyt}
        />
        <KycBlocked
          handleVerification={handleVerification}
          setShowKytBlocked={setShowKytBlocked}
          showKytBlocked={showKytBlocked}
        />
        <KyconHold setShowKyt={setShowKycReview} showKyt={showKycReview} />
        {isConflict &&
          <AppDialogHalfScreen show={isConflict} setShow={setIsConflict}>
            <Box color={'#F8F8F8'}>

              <Typography variant="subtitle2" fontSize={18} fontWeight={700}>Error</Typography>
              <Typography variant="subtitle2" fontSize={15} textAlign={"left"}>{t('transferFailed')}</Typography>
              <Typography variant="subtitle2"
                data-i18n={`[html]contactAssistance`}
                textAlign={"left"} sx={{ fontSize: "15px" }}>
                <Trans
                  components={{
                    a: (
                      <Link
                        href="mailto:support@rocketfuel.inc"
                        target="_blank"
                        onClick={() => { }}
                      />
                    ),
                  }}
                >
                  {t('contactAssistance')}

                </Trans>
              </Typography>

            </Box>
            <AppButton
              sx={{ marginTop: 2 }}
              startIcon={<HomeOutlined />}
              onClick={() => navigate("/home", {
                state: {
                  showFeedbackForm: true
                },
              })}
              title={t("BackDashboard")}
            ></AppButton>
          </AppDialogHalfScreen>
        }
        {(bankList.length <= 0 && !fiatService?.enableFiat) && 
        <Box paddingTop={10}>
          <Typography textAlign={'center'} fontSize={14}>{t('bankDisabled')}</Typography></Box>}
        { !(bankList.length <= 0 && !fiatService?.enableFiat) && (bankList?.length === 0 || bankFlag) && <LinearProgress variant="determinate" value={caluclate * (active - 1)} />}
        {!(bankList.length <= 0 && !fiatService?.enableFiat) &&
        <Container maxWidth="sm">
          {(active === 2 && (bankList?.length === 0 || bankFlag)) && <OptionSelect active={active}
            setActive={setActive}
            country={country}
            setCountry={setCountry}
            currency={currency}
            setCurrency={setCurrency}
            fiatOption={fiatOption}
            setFiatOption={setFiatOption}
            destinationRecord={destinationRecord}
            setOptionSelectMode={setOptionSelectMode}
            setDestinationRecord={setDestinationRecord}/>}

            <ClearJunction active={active} setActive={setActive} amount={0} mode={BANK_MODE} country={country} currency={currency} fiatOption={fiatOption} destinationRecord={destinationRecord}/>

        </Container>}
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Bank;
